import React, { useState } from "react";
import { Modal, Form, Button } from "react-bootstrap";
import Select from "react-select";
import "./Send_Btn_Expert_Modal.css";
import Request_Send_Modal from "../../request-send-modal/Request_Send_Modal";

function Send_Btn_Expert_Modal({ show, handleClose }) {
  const [showRequestSent, setShowRequestSent] = useState(false);
  const professionOptions = [
    { value: "doctor", label: "Doctor" },
    { value: "engineer", label: "Engineer" },
  ];

  const radiusOptions = [
    { value: "10", label: "10 KM" },
    { value: "20", label: "20 KM" },
  ];

  const startTimeOptions = [
    { value: "week", label: "Within a Week" },
    { value: "month", label: "Within a Month" },
  ];

  const selectStyles = {
    control: (base) => ({
      ...base,
      border: "none",
      boxShadow: "none",
      background: "transparent",
      minHeight: "20px",
    }),
  };
 const handleRequestSendClick = () => {
  handleClose();

  setShowRequestSent(true);

 
  setTimeout(() => {
    setShowRequestSent(false);
  }, 3000);
};
  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        centered
        className="inquiry-modal"
        size="md"
      >
        <Modal.Body className="p-4">
          <Form>
            <div className="Scroll-modal">
              <div className="custom-input-group">
                <span className="floating-label">Full Name</span>
                <Form.Control
                  type="text"
                  placeholder="Full Name"
                  className="custom-input"
                />
              </div>

              <div className="custom-input-group">
                <span className="floating-label">Mobile No</span>
                <Form.Control
                  type="text"
                  placeholder="Mobile No"
                  className="custom-input"
                />
              </div>

              <div className="custom-input-group">
                <span className="floating-label">Profession</span>
                <Select
                  options={professionOptions}
                  styles={selectStyles}
                  defaultValue={professionOptions[0]}
                  isSearchable={false}
                  placeholder="Profession"
                />
              </div>

              <div className="custom-input-group">
                <span className="floating-label">State</span>
                <Form.Control
                  type="text"
                  placeholder="State"
                  className="custom-input"
                />
              </div>

              <div className="custom-input-group">
                <span className="floating-label">District</span>
                <Form.Control
                  type="text"
                  placeholder="District"
                  className="custom-input"
                />
              </div>

              <div className="custom-input-group">
                <span className="floating-label">Taluka</span>
                <Form.Control
                  type="text"
                  placeholder="Taluka"
                  className="custom-input"
                />
              </div>

              <div className="custom-input-group">
                <span className="floating-label">Area</span>
                <Form.Control
                  type="text"
                  placeholder="Area"
                  className="custom-input"
                />
              </div>

              <div className="custom-input-group">
                <span className="floating-label">Work Start Time</span>
                <Select
                  options={startTimeOptions}
                  styles={selectStyles}
                  defaultValue={startTimeOptions[0]}
                  isSearchable={false}
                  placeholder="Work Start Time"
                />
              </div>
            </div>

            <div className="text-center mt-4">
              <Button
                className="submit-inquiry-pill"
                onClick={handleRequestSendClick}
              >
                Send Inquiry
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>

      <Request_Send_Modal
        showRequestSent={showRequestSent}
        handleRequestSendClose={() => setShowRequestSent(false)}
      />
    </>
  );
}

export default Send_Btn_Expert_Modal;
